import { alpha, type Theme } from '@mui/material/styles';

export const reportingPanelStyles = (theme: Theme) => ({
	bgcolor: 'background.paper',
	borderColor: 'divider',
	borderRadius: 1,
	boxShadow:
		theme.palette.mode === 'dark'
			? `0 8px 24px ${alpha(theme.palette.common.black, 0.28)}`
			: `0 8px 24px ${alpha(theme.palette.common.black, 0.08)}`,
});

export const reportNavigationStyles = (theme: Theme) => ({
	...reportingPanelStyles(theme),
	boxShadow:
		theme.palette.mode === 'dark'
			? `0 4px 16px ${alpha(theme.palette.common.black, 0.22)}`
			: `0 4px 16px ${alpha(theme.palette.common.black, 0.06)}`,
});
